import type { IPlatformVisual, PlatformVisualOptions } from '../IRenderer';

/**
 * PlatformVisual factory.
 *
 * Phase H10 Arc λ.10 (2026-05-10): PhaserPlatformVisual fallback removed.
 * PixiFactoriesRegistry wires the Pixi impl at boot.
 */

type PixiFactory = (opts: PlatformVisualOptions) => IPlatformVisual;

let pixiFactory: PixiFactory | null = null;

export function registerPixiPlatformVisualFactory(fn: PixiFactory): void {
  pixiFactory = fn;
}

export function createPlatformVisual(
  _scene: unknown,
  opts: PlatformVisualOptions,
): IPlatformVisual {
  if (!pixiFactory) {
    throw new Error('[createPlatformVisual] Pixi factory not registered. Call registerAllPixiFactories() at boot.');
  }
  return pixiFactory(opts);
}
